<template>
  <div v-if="contextData">
    <SectionCard01CarouselImage01
      v-if="contextData.type === 'carousel'"
      :title="contextData.title"
      :description="contextData.description"
      :items="contextItems"
      :theme="theme"
    />
    <SectionCard03
      v-else
      :title="contextData.title"
      :description="contextData.description"
      :items="contextItems"
    />
  </div>
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description: string;
    link: string;
    linkName: string;
    thumbnail: string;
    trackingCode?: string;
  }

  interface IListProductsData {
    title: string;
    description?: string;
    items: IItem[];
    type: 'carousel' | 'grid';
  }

  interface IListProducts {
    component: 'list-products';
    meta: {
      navigable?: string;
    };
    data: IListProductsData;
  }

  type IProps = ISuiteProps<IListProducts>;

  const props = defineProps<IProps>();

  const solutionsStore = useSolutionsStore();
  const { themeStyle } = storeToRefs(solutionsStore);

  const { provideFormatUrl } = useFormatUrl();
  const { provideSuiteThumbnailUrl } = useImagePath(props.urlConnector);

  const contextData = computed((): IListProductsData => props.suiteData.data);

  const contextItems = computed((): IItem[] =>
    contextData.value.items.map((item) => ({
      ...item,
      thumbnail: provideSuiteThumbnailUrl(item.thumbnail),
      link: provideFormatUrl(item.link),
    }))
  );

  const theme = computed((): TTheme => {
    switch (themeStyle.value) {
      case 'sustainable':
        return 'green';
      case 'connected':
        return 'cyan';
      case 'ai':
        return 'purple';
      case 'operations':
        return 'yellow';
      default:
        return 'blue';
    }
  });

  export type { IItem, IListProducts, IListProductsData };
</script>
